Vue.asyncComponent('cms-grid', {
    computed: {
        activeBundle() {
            return this.bundle ? this.bundle : this.$route.params.bundle;
        },
        activeGridDefinition() {
            return this.gridDefinition ? this.gridDefinition : this.$route.params.gridDefinition;
        },
        activeQuery () {
            return this.query ? this.query : this.$route.query;
        }
    },
    props: {
        bundle: {
            type: String,
            required: false
        },
        gridDefinition: {
            type: String,
            required: false
        },
        query: {
            type: String
        },
        inline: {
            type: Boolean,
            default: false
        },
        hideOnEmpty: {
            type: Boolean,
            default: false
        },
        forceMobile: {
            type: Boolean,
            default: false
        },
        hideItemsPerPage: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        updateQuery(query) {
            this.$router.push({...this.$route, query: query});
        },
        goToForm(data) {
            const params = {
                bundle: data.bundleId,
                definition: data.definitionId,
                objectId: data.objectId,
            }

            if(data.gridDefinitionId) {
                params.gridDefinition = data.gridDefinitionId;
            }

            this.$router.push({
                name: 'form',
                params: params,
                query: data.query
            });
        },
        goToGrid(data) {
            const params = {
                bundle: data.bundleId,
                gridDefinition: data.definitionId,
            };

            this.$router.push({
                name: 'grid' ,
                params: params,
                query: data.query
            });
        }
    }
}, 'cms/pages/cms-grid.html');